const PolicyStatus = Object.freeze({
  ACTIVE: 'ACTIVE',
  CANCELLED: 'CANCELLED',
  NOT_COVERED: 'NOT COVERED',
  REMOVED: 'REMOVED',
  SUSPENDED: 'SUSPENDED',
  TERMINATED: 'TERMINATED',
});

export default PolicyStatus;
